import React, { useEffect, useState } from "react";
import ContentLoader from "react-content-loader";
import { USER_DASHBOARD_BULLION } from "../../../../constants";
import { useDispatch, useSelector } from "react-redux";
import { useFieldArray, useForm } from "react-hook-form";
import { updateCompanyDashboardAction } from "../../../../actions/companyDashboard";
export default function ShareHolderCapital() {
    const dispatch = useDispatch();
    const { reset, register, handleSubmit, control } = useForm();
    const { fields, append, remove } = useFieldArray({
        control,
        name: "shareholders",
    });
    const { companyDashboard, isCompanyDashboardLoading } = useSelector(
        (state) => state.companyDashboard
    );
    const { shareHolder, pendingShareholderList, loadShareholder } = useSelector((state) => state.shareHolder);
    const { selectedCompany } = useSelector((state) => state.company);

    const { isAdminLoggedIn } = useSelector((state) => state.auth);
    const [isEditing, setIsEditing] = useState(null);

    useEffect(() => {
        const getProductAllocation = () => {
            reset();
            companyDashboard &&
                companyDashboard?.shareholders?.length > 0 &&
                companyDashboard?.shareholders.forEach((element) => {
                    append({
                        name: element?.name,
                        shares: element?.shares,
                        currency: element?.currency,
                        shareType: element?.shareType,
                    });
                });
        };
        getProductAllocation();
    }, [companyDashboard]);

    const onSubmit = async (data) => {
        const { id } = selectedCompany;
        if (id) {
            await dispatch(updateCompanyDashboardAction(id, data));
        }
        setIsEditing(null);
    };

    return (
        <>
            <div className="accountBorderSection">
                {isCompanyDashboardLoading ? (
                    <div className="row cashHederSectionPadding">
                        <div className="col-md-12">
                            <div style={{ width: "100%", marginLeft: "auto" }}>
                                <ContentLoader width="100%" height={15}>
                                    <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                                </ContentLoader>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="companyTableHolder">
                        <div className="row cashHederSectionPadding">
                            <div className="col-md-6 col-6 button_align">
                                <h6 className="cashHeaderText cashDarkText m-0">
                                    Shareholder (s)
                                </h6>
                            </div>
                            <div className="col-md-6 col-6 button_align justify-content-end">
                                {isAdminLoggedIn &&
                                    (isEditing === USER_DASHBOARD_BULLION.SHARECAPITAL ? (
                                        <button
                                            className="save-button customFilterButton"
                                            type="button"
                                            onClick={handleSubmit(onSubmit)}>
                                            Save
                                        </button>
                                    ) : (
                                        <span
                                            className="btn btn-link  px-3 mb-0 edit-button editButton"
                                            onClick={() =>
                                                setIsEditing(USER_DASHBOARD_BULLION.SHARECAPITAL)
                                            }>
                                            <i className="fas fa-pencil-alt edit-button me-2"></i>
                                        </span>
                                    ))}
                            </div>
                        </div>
                    </div>
                )}

                <div className="col-12"><hr className="m-0"></hr></div>
                <div className="content-row-padding">
                    <div className="row">
                        <div className={`col-${isEditing === USER_DASHBOARD_BULLION.SHARECAPITAL ? 3 : 3}`}>
                            <p className="accountPrimaryText m-0">Name</p>
                        </div>
                        <div className={`col-${isEditing === USER_DASHBOARD_BULLION.SHARECAPITAL ? 2 : 3}`}>
                            <p className="accountPrimaryText m-0">Number of shares</p>
                        </div>
                        <div className={`col-${isEditing === USER_DASHBOARD_BULLION.SHARECAPITAL ? 2 : 3}`}>
                            <p className="accountPrimaryText m-0">Currency</p>
                        </div>
                        <div className={`col-${isEditing === USER_DASHBOARD_BULLION.SHARECAPITAL ? 3 : 3}`}>
                            <p className="accountPrimaryText m-0">Share type</p>
                        </div>
                        {isEditing === USER_DASHBOARD_BULLION.SHARECAPITAL ? (
                            <div className="col-2 deleteIcon">
                                <p className="accountPrimaryText m-0">Action</p>
                            </div>
                        ) : (
                            <></>
                        )}
                    </div>
                    {isCompanyDashboardLoading ? (
                        <div className="row">
                            <div className="col-12 currentBalanceDetails">
                                <ContentLoader width="100%" height={15}>
                                    <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                                </ContentLoader>
                            </div>
                        </div>
                    ) : (
                        fields?.length > 0 ?
                            fields?.map((record, index) => (
                                <div key={index} className="row">
                                    <div className={`col-${isEditing === USER_DASHBOARD_BULLION.SHARECAPITAL ? 3 : 3}`}>
                                        <div className="editPayout">
                                            {isEditing === USER_DASHBOARD_BULLION.SHARECAPITAL ? (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    {...register(`shareholders.${index}.name`, {
                                                        required: true,
                                                    })}
                                                />
                                            ) : (
                                                <div className='accountSecondaryText'>{record?.name || "-"}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`col-${isEditing === USER_DASHBOARD_BULLION.SHARECAPITAL ? 2 : 3}`}>
                                        <div className="editPayout">
                                            {isEditing === USER_DASHBOARD_BULLION.SHARECAPITAL ? (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    {...register(`shareholders.${index}.shares`, {
                                                        required: true,
                                                    })}
                                                />
                                            ) : (
                                                <p className="accountSecondaryText m-0 pb-0">{record?.shares || "-"}</p>
                                            )}
                                        </div>
                                    </div>

                                    <div className={`col-${isEditing === USER_DASHBOARD_BULLION.SHARECAPITAL ? 2 : 3}`}>
                                        <div className="editPayout">
                                            {isEditing === USER_DASHBOARD_BULLION.SHARECAPITAL ? (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    {...register(`shareholders.${index}.currency`, {
                                                        required: true,
                                                    })}
                                                />
                                            ) : (
                                                <p className="accountSecondaryText m-0 pb-0">{record?.currency?.toUpperCase() || "-"}</p>
                                            )}
                                        </div>
                                    </div>

                                    <div className={`col-${isEditing === USER_DASHBOARD_BULLION.SHARECAPITAL ? 3 : 3}`}>
                                        <div className="editPayout">
                                            {isEditing === USER_DASHBOARD_BULLION.SHARECAPITAL ? (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    {...register(`shareholders.${index}.shareType`, {
                                                        required: true,
                                                    })}
                                                />
                                            ) : (
                                                <p className="accountSecondaryText m-0 pb-0">{record?.shareType || "-"}</p>
                                            )}
                                        </div>
                                    </div>
                                    {isEditing === USER_DASHBOARD_BULLION.SHARECAPITAL ? (
                                        <div className="col-2 deleteIcon">
                                            <div className="editPayout">
                                                <div
                                                    onClick={() => {
                                                        remove(index);
                                                    }}>
                                                    <span className="mb-0">
                                                        <i className="fa fa-times-circle edit-button m-0"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            ))
                            :
                            <div className="companyTableHolderRow">
                                <div className="row">
                                    <div className={`col-3`}>
                                        <div className='accountSecondaryText text-uppercase'>-</div>
                                    </div>
                                    <div className={`col-3`}>
                                        <div className='accountSecondaryText text-uppercase'>-</div>
                                    </div>
                                    <div className={`col-3`}>
                                        <div className='accountSecondaryText text-uppercase'>-</div>
                                    </div>
                                    <div className={`col-3`}>
                                        <div className='accountSecondaryText text-uppercase'>-</div>
                                    </div>
                                </div>
                            </div>
                    )}
                    {isEditing === USER_DASHBOARD_BULLION.SHARECAPITAL ? (
                        <div className="row">
                            <div className="col-12 addRowAlignIcon addRightPadding">
                                <span
                                    className="btn btn-link  px-3 mb-0 edit-button"
                                    onClick={() => {
                                        append({
                                            name: "",
                                            shares: "",
                                            currency: "",
                                            shareType: "",
                                        });
                                    }}>
                                    <i className="fa-solid fa-plus edit-button"></i>
                                </span>
                            </div>
                        </div>) : (
                        <></>
                    )}
                </div>
                {shareHolder?.length > 0 && shareHolder?.some((item) => item?.verification === "myinfo") &&
                    <>
                        <div className="col-12">
                            <hr className="m-0"></hr>
                        </div>
                        <div className="row cashHederSectionPadding">
                            <div className="col-md-6 col-6 button_align">
                                <h6 className="cashHeaderText cashDarkText m-0">
                                    MyInfo shareholder (s)
                                </h6>
                            </div>
                        </div>
                        <div className="col-12">
                            <hr className="m-0"></hr>
                        </div>
                        <div className="content-row-padding">
                            <div className="row">
                                <div className="col-3">
                                    <p className="accountPrimaryText m-0">Name</p>
                                </div>
                                <div className="col-3">
                                    <p className="accountPrimaryText m-0">Number of shares</p>
                                </div>
                                <div className="col-3">
                                    <p className="accountPrimaryText m-0">Currency</p>
                                </div>
                                <div className="col-3">
                                    <p className="accountPrimaryText m-0">Share type</p>
                                </div>

                                {isCompanyDashboardLoading ? (
                                    <div className="row">
                                        <div className="col-12 currentBalanceDetails">
                                            <ContentLoader width="100%" height={15}>
                                                <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                                            </ContentLoader>
                                        </div>
                                    </div>
                                ) : (
                                    shareHolder?.filter((item) => item?.verification === "myinfo")?.length > 0 ?
                                        shareHolder?.filter((item) => item?.verification === "myinfo")?.map((record, index) => (
                                            <div className="companyTableHolderRow">
                                                <div key={index} className="row">
                                                    <div className="col-3">
                                                        <div className='accountSecondaryText'>{record?.name}</div>
                                                    </div>
                                                    <div className="col-3">
                                                        <div className='accountSecondaryText text-uppercase'>-</div>
                                                    </div>
                                                    <div className="col-3">
                                                        <div className='accountSecondaryText text-uppercase'>-</div>
                                                    </div>
                                                    <div className="col-3">
                                                        <div className='accountSecondaryText text-uppercase'>-</div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                        :
                                        <div className="companyTableHolderRow">
                                            <div className="row">
                                                <div className={`col-3`}>
                                                    <p className="currentBalanceDetails m-0 payoutBalance">-</p>
                                                </div>
                                                <div className={`col-3`}>
                                                    <p className="currentBalanceDetails m-0 payoutBalance">-</p>
                                                </div>
                                                <div className={`col-3`}>
                                                    <p className="currentBalanceDetails m-0 payoutBalance">-</p>
                                                </div>
                                                <div className={`col-3`}>
                                                    <p className="currentBalanceDetails m-0 payoutBalance">-</p>
                                                </div>
                                            </div>
                                        </div>
                                )}
                            </div>
                        </div>
                    </>
                }
            </div >
        </>
    );
}
